import styles from './PageProductHero.module.css';
import PageProductHeroLogoPeacock from './PageProductHeroLogoPeacock.js';
import PageProductHeroTextH1 from './PageProductHeroTextH1.js';
import PageProductSignInLink from './PageProductSignInLink.js';
import PageProductHeroGradientOverlay from './PageProductHeroGradientOverlay.js';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import LogoBasic from './LogoBasic.js';
import IconPlus from './IconPlus.js';
import PageProductCallToActionRenew from './PageProductCallToActionRenew.js';
import PageProductHeroCallToActionBasic from './PageProductHeroCallToActionBasic.js';
import classNames from 'classnames';

function PageProductHero() {
  const {
    productSku,
    heroSubcopy,
    partnerLogoUrl,
    showCallToActionRenew,
    callToActionHeroText,
    showHeroLogo,
    heroEyebrow,
    heroBackgroundUrl,
    heroBackgroundPosition,
    heroBackgroundSmallDesktopUrl,
    heroBackgroundSmallDesktopPosition,
    heroBackgroundTabletUrl,
    heroBackgroundTabletPosition,
    heroBackgroundMobileUrl,
    heroBackgroundMobilePosition,
    showPortfolioValuePropositionsSection,
    showPageProductStockScreenerGate,
  } = useSearchParamOrDefaultProps();

  const isPrimaryProductRegisteredOnly = productSku === 'RegisteredOnly';
  const isPortfolioPage = showPortfolioValuePropositionsSection === 'true';
  const isStockScreenerGate =
    !isPortfolioPage && showPageProductStockScreenerGate === 'true';
  const shouldRenderCallToActionRenew =
    showCallToActionRenew === 'true' && !isPrimaryProductRegisteredOnly;

  const heroBackgroundStyle = {};
  if (heroBackgroundUrl) {
    heroBackgroundStyle['--heroExternalBackgroundUrl'] =
      `url(${heroBackgroundUrl})`;
  }
  if (heroBackgroundSmallDesktopUrl) {
    heroBackgroundStyle['--heroExternalBackgroundSmallDesktopUrl'] =
      `url(${heroBackgroundSmallDesktopUrl})`;
  }
  if (heroBackgroundTabletUrl) {
    heroBackgroundStyle['--heroExternalBackgroundTabletUrl'] =
      `url(${heroBackgroundTabletUrl})`;
  }
  if (heroBackgroundMobileUrl) {
    heroBackgroundStyle['--heroExternalBackgroundMobileUrl'] =
      `url(${heroBackgroundMobileUrl})`;
  }
  if (heroBackgroundPosition) {
    heroBackgroundStyle['--heroExternalBackgroundPosition'] =
      heroBackgroundPosition;
  }
  if (heroBackgroundSmallDesktopPosition) {
    heroBackgroundStyle['--heroExternalBackgroundSmallDesktopPosition'] =
      heroBackgroundSmallDesktopPosition;
  }
  if (heroBackgroundTabletPosition) {
    heroBackgroundStyle['--heroExternalBackgroundTabletPosition'] =
      heroBackgroundTabletPosition;
  }
  if (heroBackgroundMobilePosition) {
    heroBackgroundStyle['--heroExternalBackgroundMobilePosition'] =
      heroBackgroundMobilePosition;
  }

  return (
    <section
      className={classNames(styles.PageProductHero, {
        [styles.PageProductHeroPortfolio]: isPortfolioPage,
      })}
      style={heroBackgroundStyle}
    >
      <PageProductHeroGradientOverlay />
      <PageProductHeroLogoPeacock
        strokeColor={'var(--heroLogoPeacockStrokeColor)'}
        strokeOpacity={0.2}
      />
      <div
        className={classNames(styles.heroContentsWrapper, {
          [styles.heroContentsWrapperPortfolio]: isPortfolioPage,
        })}
      >
        <div
          className={classNames(styles.logoContainer, {
            [styles.logoContainerPortfolio]: isPortfolioPage,
          })}
        >
          {showHeroLogo === 'true' && (
            <LogoBasic
              style={{
                width: 'var(--heroProductLogoWidth, 138px)',
                height: '100%',
                maxHeight: 'unset',
              }}
            />
          )}

          {partnerLogoUrl && (
            <>
              <IconPlus margin={'15px'} fill={'#CFD8E2'} />
              <LogoBasic backgroundImage={`url('${partnerLogoUrl}')`} />
            </>
          )}
        </div>

        {heroEyebrow && <div className={styles.eyebrow}>{heroEyebrow}</div>}

        <PageProductHeroTextH1 />

        <p
          className={classNames(styles.subcopy, {
            [styles.subcopyPortfolio]: isPortfolioPage,
            [styles.subcopyStockScreenerGate]: isStockScreenerGate,
          })}
        >
          {heroSubcopy}
        </p>

        {shouldRenderCallToActionRenew ? (
          <PageProductCallToActionRenew
            callToActionTextOverride={callToActionHeroText}
          />
        ) : (
          <PageProductHeroCallToActionBasic width={'281px'} height={'64px'} />
        )}

        {isPortfolioPage ? (
          <div className={styles.heroFooterCnbcPlaidContainer}>
            <div className={styles.heroFooterLogoContainer}>
              <div className={styles.heroFooterCnbcLogo}>
                <img
                  src="/images/portfolio-hero-footer-cnbc-logo.svg"
                  alt="cnbc"
                />
              </div>
              <div className={styles.heroFooterArrowsLogo}>
                <img
                  src="/images/portfolio-hero-footer-arrows-logo.svg"
                  alt="cnbc"
                />
              </div>
              <div className={styles.heroFooterPlaidLogo}>
                <img
                  src="/images/portfolio-hero-footer-plaid-logo.svg"
                  alt="cnbc"
                />
              </div>
            </div>
            <div className={styles.heroFooterText}>
              <b>Plaid</b> uses secure encryption to help protect your data
            </div>
          </div>
        ) : (
          <PageProductSignInLink isMobile={false} />
        )}
      </div>
    </section>
  );
}

export default PageProductHero;
